import React from "react";
import apple from "../assets/apple.png";
import google from "../assets/google.png";

function DownloadApp() {
  return (
    <div className="download">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="row items-center h-[450px]">
          <div className="w-full md:w-8/12 lg:6/12 xl:5/12">
            <h1 className="heading">download app</h1>
            <h1 className="text-3xl font-medium mt-4 capitalize">
              get access to our mobile app
            </h1>
            <p className="text-gray-800 mt-4">
              Easily order food throgh your phone and get your order instantly
              to your doorstep
            </p>

            <div className="mt-5 flex gap-2">
              <img src={apple} alt="" />

              <img src={google} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DownloadApp;
